import React from "react";
import Subheading from "../../../components/common/Subheading";
import Title from "../../../components/common/Title";

/**
 * Derive ECS container log stream segment from Mongo Log Stream Name.
 * @param {string} logStreamName
 * @returns {string}
 */
function getContainerLogSegment(logStreamName) {
  const name = (logStreamName || "").toLowerCase();
  if (name.includes("data checker")) {
    return "ecs-data-checker-container";
  }
  if (name.includes("auto4client")) {
    return "ecs-auto4client-container";
  }
  if (name.includes("geocoder")) {
    return "ecs-geocoder-container";
  }
  return "ecs-scraper-container";
}

/**
 * Displays metadata about the current log stream task
 *
 * @param {Object} props Component props
 * @param {boolean} props.taskFinished Whether the task has completed
 * @param {number} props.errorCount Number of errors in the log stream
 * @param {number} props.warningCount Number of warnings in the log stream
 * @param {Object} props.logStreamMongoData Additional metadata from MongoDB
 * @returns {JSX.Element} Rendered TaskMetadata component
 */
function TaskMetadata({ taskFinished, errorCount, warningCount, logStreamMongoData }) {
  const containerSegment = getContainerLogSegment(logStreamMongoData["Log Stream Name"]);

  return (
    <>
      {taskFinished && <Title text={"Scraper Has Terminated Successfully!"} />}
      <Subheading text={`Errors Found: ${errorCount}`} sx={{ color: "#DC143C" }} />
      <Subheading text={`Warnings Found: ${warningCount}`} sx={{ color: "#dcad14" }} />
      <Subheading
        text={
          logStreamMongoData["Scraper Args Hash"]
            ? `Scraper Args Hash: ${logStreamMongoData["Scraper Args Hash"]}`
            : null
        }
      />
      <Subheading
        text={
          logStreamMongoData["Task ID"]
            ? `Container Log Stream: logs/${containerSegment}/${logStreamMongoData["Task ID"]}`
            : null
        }
      />
    </>
  );
}

export default TaskMetadata;
